export default "https://static-service.opploans-assets.com/assets/webpack/bcce1e83d58c3ea188774b6858ccca83.gif";